module.exports = __webpack_public_path__ + "img/bitcoin.219c2be0.png";